import { render } from "./ControlArea.vue?vue&type=template&id=0490bdc5&scoped=true"
import script from "./ControlArea.vue?vue&type=script&lang=js"
export * from "./ControlArea.vue?vue&type=script&lang=js"

import "./ControlArea.vue?vue&type=style&index=0&id=0490bdc5&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0490bdc5"]])

export default __exports__